import { Key } from "@mui/icons-material";
import { Box, Grid, Modal, Typography } from "@mui/material";
import Button from "components/Button";
import { useState } from "react";
import { useIntl } from "react-intl";
import ParkkiTheme from "themes/ParkkiTheme";

export const SSOLoginModal = () => {
  const [open, setOpen] = useState(false);
  const intl = useIntl();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        marginTop: "12px",
        width: "100%",
        justifyContent: "end",
      }}
    >
      <Button
        style={{ backgroundColor: "white", color: "black", width: "20%" }}
        label={
          <>
            <Key
              style={{
                marginRight: "8px",
                transform: "rotate(-45deg)",
                width: "20px",
              }}
            />
            {intl.formatMessage({
              id: "loginScene.login.ssoLabel",
            })}
          </>
        }
        onClick={() => setOpen(true)}
      />
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            backgroundColor: ParkkiTheme.colors.blue,
            color: "white",
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {intl.formatMessage({
              id: "loginScene.login.ssoLoginModalTitle",
            })}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {intl.formatMessage({
              id: "loginScene.login.ssoLoginModalDescription",
            })}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <Button
                style={{ marginTop: "12px" }}
                label={intl.formatMessage({
                  id: "loginScene.login.ssoLoginButton.chalonsEnChampagne",
                })}
                onClick={() => {
                  window.location.href = `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_SSO_CHALONS_CONNECT_PATH}`;
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};
